import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { KycDocumentsResponse } from './types/Kyc';

export default (makeCall: MakeCall) =>
  (
    userId: 'me' | number,
    kycUuid: string,
    data: {
      documentUuid: string;
      documentType: string;
    },
  ) =>
    makeCall<KycDocumentsResponse>(
      'POST',
      `/api/v2/user/${userId}/kyc/${kycUuid}/documents`,
      {
        data,
      },
    );
